import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { getFTTBFirewallService } from 'pages/Internet/store/selectors/firewallSelectors';
import { ErrorStatus } from '../../../../components';

export const FirewallErrorConnected = compose(
  connect((state) => ({
    error: getFTTBFirewallService(state).error,
    shouldRender: !!getFTTBFirewallService(state).error,
  })), withRenderFlag,
)(ErrorStatus);
